import { PayloadMessageInterface } from "../interfaces/messagesInterface";
import { MESSAGE } from "../reducers/messages";

export const newMessage = (payload: PayloadMessageInterface) => {
    return{
        type: MESSAGE.NEW,
        payload
    }
}

export const clearHistory = () => {
    return {
        type: MESSAGE.CLEAR
    }
}